<template>
	<div class="content">
		<div class="menu-right">
			<div class="title">
				<span>服务条款</span>
			</div>
			<div class="descript">
				<h4>{{descript.title}}</h4>
				<p v-for="(item,index) in descript.list">{{item.text}}</p>
			</div>
			<div class="inner" v-for="(item,index) in clauseList" :key="index">
				<div class="sm-title">{{item.title}}</div>
				<div v-for="(item1,index1) in item.list" :key="index1">
					<h4>{{item1.title}}</h4>
					<p v-for="(item2,index2) in item1.list" :key="index2">{{item2.text}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			descript: {
				title: '【首部及导言】',
				list: [
					{text: '欢迎您使用派派回收app回收服务！派派回收回收服务是指派派回收按照以下条款的约定对您的手机进行回收并将回收款按照您预留的支付方式打款到您账户的服务。'},
					{text: '以下条款中所提及的手机、手表、平板、电脑、产品、设备、数码产品、二手数码产品均指向派派回收回收服务的标的物。'},
					{text: '本服务是由深圳网飘科技有限公司（统一社会信用代码：91440300349856768X）提供。在使用本服务前，请您务必审慎阅读、充分理解并遵守《派派回收回收服务条款》各条款内容，特别是第二部分免除或限制责任的相应条款。限制或免除责任条款可能以加粗形式提示您注意。'}
				]
			},
			clauseList: [
				{
					title: '一、回收流程',
					list: [
						{
							title: '1.回收流程',
							list: [
								{text:'选择您要回收的机型——线上估价——下单——选择收款方式——我方收件质检——确认最终回收价格——交易完成。'}
							]
						},
						{
							title: '2.选择您要回收的机器型号',
							list: [
								{text: '（1）您应保证回收物品是正规渠道来源，派派回收拒绝回收山寨机、高仿机等其他非法渠道物品（如丢失、捡到、有租约未完成的机器）。'},
								{text: '（2）您应保证对交易物品拥有合法、完整的处分权利。如果证实您持有的机器来源属非法，派派回收有权利在遵守国家相关法律法规前提下，将物品移交给公安司法机关，并且向您索赔对应的快递费用等其他经济损失。'},
								{text: '（3）您要确保下单描述的物品参数信息准确、真实、有效。因填写错误的物品参数信息导致回收物品出现的价格差，您应自行承担该后果；'},
								{text: '（4）您的回收设备型号在派派回收回收机型列表中，或者不在回收列表中，但经客服确认可以回收的机型。'}
							]
						},
						{
							title: '3.邮寄方式',
							list: [
								{text:'（1）派派回收推荐您选择顺丰上门取件，默认快递费用到付（派派回收承担快递费用）'},
								{text:'（2）如果您选择到付，手机、平板、手表派派回收最高承担25元的快递到付费用，笔记本电脑最高承担45元快递到付费用。'},
								{text:'（3）如果您选择寄付：由广东省内寄出派派回收最高报销13元快递费用，由广东省外寄出派派回收最高报销18元快递费用。报销款项会和回收款项一起支付到您账户。'},
								{text:'（4）山寨机、高仿机、锁屏密码没有解除、id账户没有退出、丢失模式、无法开机机器，派派回收不承担寄回等其他费用。'},
								{text:'（5）不在派派回收回收机型列表中或未经客服确认可以回收的机型，派派回收有权对该设备拒签，且免于快递费用的承担。'}
							]
						},
						{
							title: '4.收款方式、质检内容',
							list: [
								{text:'（1）目前现有四种收款方式：分别为微信、支付宝、银行卡、购机抵扣券。'},
								{text:'（2）派派回收在收到您的机器之后会根据您下单时候提供的情况进行不损坏机器的检测比对，需要打开部分手机的屏幕前盖或后盖，确认机器是否存在进水和拆修等情况，不会对机器造成功能影响。对于以下机器派派回收承诺不拆机：（a）一体机（b）机身破损严重（c）其他拆机可能会对机器造成价值受损情况。'},
								{text:'（3）质检完成会会告知您回收价格。如果有检测差异，会根据您机器的实际情况进行修正报价并通知您。您可以选择继续回收，或者选择取消并寄回。如果您选择继续回收，我方会按照修正后的回收价格打款到您下单时选择收款方式所预留的账户或账号中；如果您选择取消并寄回，我方会按照您填写的寄回地址在2个工作日内顺丰寄回（顺丰不到的地区改发EMS）。'}
							]
						},
						{
							title: '5.派派回收在收到您的机器并检测完毕之后，如果检测后价格大于或者等于您提交订单记录的估价时，派派回收将无需再次联系您确认交易并直接向您付款。',
							list: []
						},
						{
							title: '6.如果您同一天选择派派回收回收您持有的机器超过2台（不包含2台）的，针对超过2台的机器，派派回收有权根据《旧电器数码产品流通管理办法》监管和实际情况决定是否回收。',
							list: []
						},
						{
							title: '7.派派回收支持的回收机型：仅支持派派回收回收机型列表上已存在的机型进行回收，对于不在列表中的品类，请咨询客服并经确认可以回收之后进行邮寄，否则派派回收将做拒签处理。',
							list: []
						},
					]
				},
				{
					title: '二、免责声明',
					list: [
						{
							title: '1.请您在数码产品回收之前确认您的手机等数码产品已经结束了所有的与派派回收无关的合约关系；并且已经移除所有数据（包括但不限于SIM卡、存储卡、声音、图片、视频、通讯录、短信、备忘录、各软件账户以及密码、等其他资料）。派派回收在任何时候不提供手机等数码产品的数据保存、提取以及传输服务。派派回收有权利对该产品进行数据清除并不承担任何法律责任。',
							list: []
						},
						{
							title: '2.您在数码产品回收之前需要确认，需要回收的数码产品已经彻底关闭并退出了与该产品的有关的锁屏密码、网络云服务账户、隐私访问密码等，并且将该产品还原了出厂设置，对于未还原以及已经还原出厂设置的设备，派派回收都会在收到设备之后进行还原出厂设置的操作，因还原或恢复出厂设置产生的任何问题由您承担。',
							list: []
						},
						{
							title: '3.配件问题：您的产品如果不是全新机器（全新机是指：未拆封、未激活使用并且享受产品销售厂商官方保修服务的产品），只需要提供一部设备用于回收即可（其它回收估价选项中有特殊说明除外）。其它与设备无关产品，比如充电器、数据线、耳机、包装盒、保修卡、说明书等均不影响产品的最终回收价格。若您寄出产品之后造成遗失，派派回收不承担任何责任。',
							list: []
						},
						{
							title: '4.如果您的二手数码产品有以下一种或多种情况：（1）无法开机；（2）触摸功能失灵、异常（3）屏幕无法正常显示；（4）机器有其他故障导致无法正常清除。派派回收无法且无义务对该类二手数码产品进行数据清除，您应知晓并自行承担其可能带来的风险和损失。',
							list: []
						},
						{
							title: '5. 您若坚持按照出现明显输入错误或依据常识不可能被认为是出售二手数码产品的真实合理价格的（比如：二手设备回收价格高于新品销售价格），派派回收有权取消或终止此类派派回收认为价格错误的订单。',
							list: []
						},
						{
							title: '6.您应在下单之后的7天内寄出订单相对应的设备，若因超时未寄出或者回收价格的下调造成设备贬值、订单取消，派派回收不承担任何责任。',
							list: []
						},
						{
							title: '7.如果设备是在派派回收签收之前，由于第三方快递的责任造成您的设备丢失、损坏等其他问题，派派回收会积极配合您与第三方快递公司协商解决方案， 但派派回收并不承担任何责任。如果是在派派回收签收之后由于自身的原因造成的设备的丢失、损坏、等其他价值降低的问题，派派回收最高按照该订单预估价格进行赔偿。',
							list: []
						},
						{
							title: '8.为了保证您在回收过程中的合法权益，派派回收会对包装有您的数码产品的包裹进行拆包、质检录像。录像内容不予以公示，但若订单产生纠纷，该录像内容可作为证据向司法机关提供。',
							list: []
						},
						{
							title: '9.您应当保证快递寄出电话、姓名和订单信息上的电话、姓名一致，派派回收在收到您的包裹之后会通过多重信息匹配到您的回收订单，如果是由于您的寄出信息错误导致的订单匹配错误问题，派派回收不承担任何责任。匹配完成之后会在48小时（法定节假日除外）内完成检测。',
							list: []
						},
						{
							title: '10.一旦您已确认回收或者打款完成，将无法退还机器（包含一起邮寄的相关所有配件），并取消订单。',
							list: []
						},
						{
							title: '11.若质检完成之后您同意回收，派派回收会在24小时内付款到您下单预留账户，如果是由于您预留信息有误导致的付款错误、失败等问题，则派派回收不承担任何责任。',
							list: []
						},
						{
							title: '12.您应该在质检完成之后的7天内，在派派回收APP操作确认回收、或者取消并寄回，若超时未操作，派派回收会按照质检后确定的最终回收价格进行打款、或按照您的寄出地址到付寄回。',
							list: []
						},
						{
							title: '13.对于取消回收寄回的情况下，您若拒签订单，派派回收会按照该订单质检后所确认的金额进行直接打款或由顺丰作废处理。',
							list: []
						},
						{
							title: '14. 您应知晓并同意该条款，若您因为不理解以上条款，导致产生任何争议及损害，包括但不限于因此产生的一切费用、资料泄露或损失，以及因此产生的所有求偿、损失、损害等，概由您自行承担，派派回收无需承担任何责任。',
							list: []
						},
						{
							title: '15.因下列原因导致我们无法正常提供服务，我们免于承担责任：',
							list: [
								{text: '（1）我们的系统停机维护或升级；'},
								{text: '（2）因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；'},
								{text: '（3）您的设备软硬件和通信线路、供电线路出现故障的；'},
								{text: '（4）因您操作不当或通过非经我们授权或认可的方式使用我们服务的；'},
								{text: '（5）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。'},
								{text: '尽管有前款约定，我们将采取合理行动积极促使服务恢复正常。 '}
							]
						},
					]
				},
				{
					title: '三、服务范围',
					list: [
						{
							title: '适用于回收页面所有回收机型的回收服务，本服务条款的效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本服务条款产生的争议，均应依照中华人民共和国法律予以处理，并由被告住所地人民法院管辖。',
							list: []
						}
					]
				}
			]
		}
	}
}
</script>

<style scoped>
.descript p{
	line-height: 30px;
	text-indent: 2em;
}
	
.menu-right .title span{
	font-size: 24px;
	border-bottom: 3px solid #FF6700;
	padding-bottom: 4px;
}

.menu-right .inner p{
	font-size: 16px;
	line-height: 30px;
	color: #282828;
	margin-top: 10px;
}

.menu-right .inner .sm-title{
	margin-top: 20px;
	color: #FF6800;
}

h4{
	margin-top: 20px;
	font-weight: normal;
}
</style>
